module.exports = __webpack_public_path__ + "img/voltage-indicator.2c47d9a7.svg";